import { gsap } from "../global/gsap";

const initLondHello = (londonHelloEl) => {
    const words = londonHelloEl.querySelectorAll('.js-word');
    if (!words.length) return;

    let currentIndex = 0;

    const tick = () => {
        words[currentIndex].classList.remove('is-active');

        currentIndex = (currentIndex + 1) % words.length;

        words[currentIndex].classList.add('is-active');

        gsap.delayedCall(0.3, tick);
    };

    tick();
};

export { initLondHello as default };